export const BASIC = "basic";
export const ESSENTIAL = "essential";
export const PRO = "pro";

export const plans = [BASIC, ESSENTIAL, PRO];
